<template>
<div class="col-xl-6 col-lg-6">
    <div class="card user-status">
        <div class="card-header pb-0">
            <h3>Product cart </h3>
        </div>
        <div class="card-body">
            <div class="table-responsive mb-0 theme-scrollbar">
                <table class="table table-bordernone">
                    <thead>
                        <tr>
                            <th scope="col">Details</th>
                            <th scope="col">Qty.</th>
                            <th scope="col">Price</th>
                            <th class="text-end" scope="col">Status</th>
                        </tr>
                    </thead>
                    <tbody v-for="(item,index) in menu" :key="index">
                        <tr>
                            <td>{{item.details}}</td>
                            <td class="digits">{{item.qty}}</td>
                            <td class="digits font-primary">{{item.price}}</td>
                            <td class="text-end"><span :class="item.class"> {{item.status}}</span></td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div></div>
          </div>
    </div>
</div>
</template>

<script>
import {
    productData
} from '../../../data/widgets/general/data'
export default {
    name: 'productPage',
    data() {
        return {
            menu: productData
        }
    }

}
</script>
